import React, { useState } from "react";
import SyllabusDetailCardProduct2 from "./SyllabusDetailCardProduct2";
import {MicSpeakingIcon, PenWritingIcon, HeadphoneListeningIcon, BookReadingIcon} from "../../../assets";

const syllabusItems = [
  {
    id: "speaking",
    title: "Speaking",
    description: "— 3 parts",
    secondaryColor: "#FBEAF0",
    icon: MicSpeakingIcon,
    primaryColor: "#D4537E",
    parts: [
      {
        badge: "PART 1",
        optionalBadge: null,
        title: "Short natural answers",
        items: [
          "Jawab topik harian dengan natural",
          "Pronunciation & intonasi",
          "Basic fluency",
          "Vocab: hobbies, work, hometown",
        ],
      },
      {
        badge: "PART 2",
        optionalBadge: "POPULAR",
        title: "2-minute monologue",
        items: [
          "Struktur monolog yang jelas",
          "Storytelling & elaborasi",
          "Paraphrasing on the spot",
          "Manajemen waktu cue card",
        ],
      },
      {
        badge: "PART 3",
        optionalBadge: null,
        title: "Analytical discussion",
        items: [
          "Jawaban kompleks & analitis",
          "Diskusi isu luas secara mendalam",
          "Spekulasi (might, could, probably)",
          "Vocab untuk diskusi formal",
        ],
      },
    ],
  },
  {
    id: "writing",
    title: "Writing",
    description: "— 2 tasks",
    secondaryColor: "#E6F1FB",
    icon: PenWritingIcon,
    primaryColor: "#2F65C8",
    parts: [
      {
        badge: "TASK 1",
        optionalBadge: null,
        title: "Data & visual description",
        items: [
          "Struktur chart/graph/table/map",
          "Menulis overview (main summary)",
          "Describe trends: increase, decrease",
          "Grammar untuk komparasi data",
        ],
      },
      {
        badge: "TASK 2",
        optionalBadge: "HIGH IMPACT",
        title: "Academic Essay",
        items: [
          "Struktur essay intro-body-conclusion",
          "Thesis statement yang kuat",
          "Cohesion & paragraph transition",
          "Complex grammar & academic vocabulary",
        ],
      },
    ],
  },
  {
    id: "listening",
    title: "Listening",
    description: "— teknik + soal",
    secondaryColor: "#FAEEDA",
    icon: HeadphoneListeningIcon,
    primaryColor: "#ba7517",
    parts: [
      {
        badge: "TEKNIK",
        optionalBadge: null,
        title: "Comprehension skills",
        items: [
          "Prediction sebelum audio",
          "Catching main ideas dan details",
          "Synonym recognition",
          "Signposting words",
        ],
      },
      {
        badge: "QUESTION TYPES",
        optionalBadge: "EXAM FOCUS",
        title: "All section types",
        items: [
          "Form & note completion",
          "Multiple choice & matching",
          "Map/plan labelling",
          "Accent: British, American, Australian",
        ],
      },
    ],
  },
  {
    id: "reading",
    title: "Reading",
    description: "— strategi + soal",
    secondaryColor: "#EAF3DE",
    icon: BookReadingIcon,
    primaryColor: "#3b6d11",
    parts: [
      {
        badge: "STRATEGI",
        optionalBadge: "core",
        title: "Speed & comprehension",
        items: [
          "Skimming & scanning efektif",
          "Identifying main ideas & opinions",
          "Paraphrasing dalam teks",
          "Time management per passage",
        ],
      },
      {
        badge: "QUESTION TYPES",
        optionalBadge: null,
        title: "Semua tipe soal",
        items: [
          "T/F/NG & Y/N/NG",
          "Matching heading",
          "Sentence & summary completion",
          "Multiple choice",
        ],
      },
    ],
  },
];

const SyllabusProduct2 = () => {
  const [expandedItem, setExpandedItem] = useState(null);

  return (
    <section className="st-syllabus-section py-16 sm:py-20 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 md:px-16">
        <div className="mb-8 flex justify-center">
          <div className="st-syllabus-badge-container flex flex-col items-center justify-center rounded-full px-6 py-2 sm:px-8 sm:py-3">
            <div className="text-xs font-bold uppercase tracking-wider sm:text-sm">
              -- Detail Silabus --
            </div>
          </div>
        </div>
        <div className="mb-8 text-center md:mb-12">
          <h2 className="st-font-display st-syllabus-title text-5xl leading-tight sm:text-6xl md:text-7xl lg:text-8xl">
            <span className="block font-bold">What <span className="font-normal italic"> You'll </span></span>
            <span className="font-bold">Learn</span>
            <span className="font-normal italic"> with </span>
            <span className="font-bold">Us</span>
            <span className="font-normal italic">?</span>
          </h2>
        </div>
        <div className="mb-12 text-center md:mb-16">
          <p className="st-font-body st-syllabus-subtitle text-lg leading-relaxed sm:text-xl md:text-2xl">
            Materi lengkap untuk bantu kamu siap di setiap section IELTS!
          </p>
        </div>
        <div className="space-y-4 sm:space-y-6">
          {syllabusItems.map((item) => (
            <div key={item.id} className="overflow-hidden rounded-3xl">
              <button
                onClick={() =>
                  setExpandedItem(expandedItem === item.id ? null : item.id)
                }
                className="st-syllabus-card-header flex w-full items-center justify-between gap-4 p-6 text-black sm:gap-6 sm:p-8"
              >
                <div
                  className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-2xl sm:h-20 sm:w-20"
                  style={{ backgroundColor: item.secondaryColor }}
                >
                  <img
                    src={item.icon}
                    alt={`${item.title} icon`}
                    className="h-8 w-8 object-contain sm:h-10 sm:w-10"
                  />
                </div>
                <div className="flex flex-1 items-center gap-3 pl-2 text-left sm:gap-4 sm:pl-4 md:gap-5 md:pl-6">
                  <h3 className="st-font-display text-2xl font-bold leading-tight sm:text-3xl md:text-5xl">
                    {item.title}
                  </h3>
                  <p className="st-font-body text-sm opacity-75 sm:text-base md:text-xl">
                    {item.description}
                  </p>
                </div>
                <div
                  className="flex h-8 w-8 flex-shrink-0 items-center justify-center transition-transform duration-300 sm:h-10 sm:w-10"
                  style={{
                    transform:
                      expandedItem === item.id
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                  }}
                >
                  <svg
                    className="h-6 w-6 sm:h-8 sm:w-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 14l-7 7m0 0l-7-7m7 7V3"
                    />
                  </svg>
                </div>
              </button>
              {expandedItem === item.id && (
                <div className="space-y-4 border-t-4 bg-[#FFCE43] p-6 sm:space-y-6 sm:p-8" style={{ borderTopColor: item.primaryColor }}>
                  {item.parts.map((part, index) => (
                    <SyllabusDetailCardProduct2
                      key={index}
                      primaryColor={item.primaryColor}
                      secondaryColor={item.secondaryColor}
                      badge={part.badge}
                      optionalBadge={part.optionalBadge}
                      title={part.title}
                      items={part.items}
                    />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SyllabusProduct2;
